// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/delete_vision_project.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/delete_vision_project.proto.
 */
export const file_vision_projects_v1_delete_vision_project: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vcHJvamVjdHMvdjEvZGVsZXRlX3Zpc2lvbl9wcm9qZWN0LnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxIogBChpEZWxldGVWaXNpb25Qcm9qZWN0UmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLkRlbGV0ZVZpc2lvblByb2plY3RSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSJ2ChtEZWxldGVWaXNpb25Qcm9qZWN0UmVzcG9uc2USTQoGcmVzdWx0GAEgASgLMj0ucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5EZWxldGVWaXNpb25Qcm9qZWN0UmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z");

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionProjectRequest
 */
export type DeleteVisionProjectRequest = Message<"protos.vision.projects.v1.DeleteVisionProjectRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.DeleteVisionProjectRequest.Params params = 1;
   */
  params?: DeleteVisionProjectRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionProjectRequest.
 * Use `create(DeleteVisionProjectRequestSchema)` to create a new message.
 */
export const DeleteVisionProjectRequestSchema: GenMessage<DeleteVisionProjectRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_project, 0);

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionProjectRequest.Params
 */
export type DeleteVisionProjectRequest_Params = Message<"protos.vision.projects.v1.DeleteVisionProjectRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionProjectRequest.Params.
 * Use `create(DeleteVisionProjectRequest_ParamsSchema)` to create a new message.
 */
export const DeleteVisionProjectRequest_ParamsSchema: GenMessage<DeleteVisionProjectRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_project, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionProjectResponse
 */
export type DeleteVisionProjectResponse = Message<"protos.vision.projects.v1.DeleteVisionProjectResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.DeleteVisionProjectResponse.Result result = 1;
   */
  result?: DeleteVisionProjectResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionProjectResponse.
 * Use `create(DeleteVisionProjectResponseSchema)` to create a new message.
 */
export const DeleteVisionProjectResponseSchema: GenMessage<DeleteVisionProjectResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_project, 1);

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionProjectResponse.Result
 */
export type DeleteVisionProjectResponse_Result = Message<"protos.vision.projects.v1.DeleteVisionProjectResponse.Result"> & {
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionProjectResponse.Result.
 * Use `create(DeleteVisionProjectResponse_ResultSchema)` to create a new message.
 */
export const DeleteVisionProjectResponse_ResultSchema: GenMessage<DeleteVisionProjectResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_project, 1, 0);

